module.exports = __webpack_public_path__ + "img/125.575f810.jpg";